import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { api } from "@/redux/api";
import { buildPortfolioPath } from "@/utils/route-context";
import ContractList from "@/containers/contract/ContractList";

export default function PortfolioContractPage() {
  const { companyId: routeCompanyId } = useParams();
  const selectedCompanyId = useSelector((state) => state.Company?.selectedId);
  const userFacilities = useSelector((state) => state.Auth?.user_facilities);
  const companyId = routeCompanyId || selectedCompanyId;
  const [selectedFacilityIds, setSelectedFacilityIds] = useState([]);

  const facilities = useMemo(() => {
    const accessibleFacilities = Array.isArray(userFacilities) ? userFacilities : [];
    return accessibleFacilities
      .filter((facility) => String(facility.company_id) === String(companyId))
      .map((facility) => ({
        id: facility.id,
        name: facility.name,
      }));
  }, [companyId, userFacilities]);

  useEffect(() => {
    setSelectedFacilityIds(facilities.map((facility) => facility.id));
  }, [companyId, facilities]);

  const loadRequests = useCallback(
    (facilityIds, params) => api.getContracts(facilityIds, params),
    []
  );
  const getDetailPath = useCallback(
    (record) => {
      return buildPortfolioPath(`contract-request-detail/${record.id}`, { companyId }) || "/switch-view";
    },
    [companyId]
  );

  return (
    <ContractList
      facilityIds={selectedFacilityIds}
      facilities={facilities}
      onFacilityChange={setSelectedFacilityIds}
      loadRequests={loadRequests}
      getDetailPath={getDetailPath}
      showFacilityColumn
      showRequesterColumn
    />
  );
}
